import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { fetchMe, logout as apiLogout, exchangeSessionId } from "../game/authService";

const AuthCtx = createContext({
  user: null,
  loading: true,
  refresh: async () => {},
  signOut: async () => {},
});

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const me = await fetchMe();
    setUser(me);
    return me;
  }, []);

  useEffect(() => {
    let cancelled = false;
    const init = async () => {
      // If returning from OAuth (`#session_id=...` in URL), exchange first
      // before checking `/auth/me`. This avoids a 401 race.
      const hash = window.location.hash || "";
      const m = hash.match(/session_id=([^&]+)/);
      if (m) {
        try {
          await exchangeSessionId(decodeURIComponent(m[1]));
        } catch {
          /* swallow — fall through to me-check */
        }
        // Clean the fragment so reloading doesn't re-exchange.
        const cleanUrl = window.location.pathname + window.location.search;
        window.history.replaceState(null, "", cleanUrl);
      }
      const me = await fetchMe();
      if (!cancelled) {
        setUser(me);
        setLoading(false);
      }
    };
    init();
    return () => {
      cancelled = true;
    };
  }, []);

  const signOut = useCallback(async () => {
    await apiLogout();
    setUser(null);
  }, []);

  return (
    <AuthCtx.Provider value={{ user, loading, refresh, signOut }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() {
  return useContext(AuthCtx);
}
